import Tools from "../Tools";
import ad_account from "../vo/dbvo/ad_account";
import ad_industry from "../vo/dbvo/ad_industry";
import ad_industry_account_map from "../vo/dbvo/ad_industry_account_map";
import ad_template from "../vo/dbvo/ad_template";

export type InputGetTemplateShopList = {
    page: number;
    pageSize: number;
    filter?: InputGetTemplateShopListFilter
};

export type InputGetTemplateShopListFilter = {
    /**
     * 筛选名称
     */
    name?: string;
    /**
     * 筛选行业ID 数组
     */
    industryIds?: number[];
    /**
     * 是否显示免费
     * 如果为true则强制筛选免费 false 只显示收费 null 显示全部
     */
    free?: boolean;
    /**
     * 价格排序(参数 asc正序 desc倒序 其它都是不排序)
     */
    orderPrice: 'asc' | 'desc' | '';
};

export type InputSaveTemplage = {
    name?: string;
    temp_unique_identifier?: string;
    templateImage?: File,
    industryIds?: number[];
    configureJson: string;
};

export type InputSetTemplateParameter = {
    tempUniqueIdentifier: string;
    name?: string;
    thumbnail?: File,
    isPublic: boolean;
    Price: number;
    Sort: number;
    isTop: boolean
}

export type InputBuyTemplate = {
    TempUniqueIdentifier: string;
};


/**
 * 模板相关API
 */
export default class TemplateApi {
    /**
     * 获取模版商店数据
     */
    public GetTemplateShopListAsync(input: InputGetTemplateShopList) {
        return Tools.FetchAsync<{
            allcount: number,
            pagecount: number,
            data: {
                template: ad_template,
                industry: ad_industry,
                user: ad_account
            }[]
        }>("Template/GetTemplateShopList", input, "POST");
    }

    /**
     * 获取模板所属行业列表
     * @param input 
     * @returns 
     */
    public GetTemplateIndustryListAsync(templateUniqueId: string) {
        return Tools.FetchAsync<
            {
                industry: ad_industry,
                templateIndustryMap: ad_industry_account_map
            }[]
        >("Template/GetTemplateIndustryList", {
            templateUniqueId
        }, "GET");
    }

    /**
     * 检查我是否购买过模板
     * @param tempUniqueIdentifier 
     */
    public GetCheckHasBuyedTemplateAsync(tempUniqueIdentifier: string) {
        return Tools.FetchAsync<{
            hasBuy: boolean
        }>("Template/GetCheckHasBuyedTemplate", { tempUniqueIdentifier }, "GET");
    }

    /**
     * 获取我的模版列表
     * @param page 
     * @param pageSize 
     * @param filterIndustry 筛选行业标签列表
     */
    public GetMyTemplateListAsync(page: number, pageSize: number, filterIndustry: string[] = []) {
        return Tools.FetchAsync<{
            allcount: number,
            pagecount: number,
            data: ad_template[]
        }>("Template/GetMyTemplateList", {
            page,
            pageSize,
            filterIndustry: JSON.stringify(filterIndustry ?? [])
        }, "GET");
    }

    /**
     * 保存模板
     */
    public SaveTemplateAsync(input: InputSaveTemplage) {
        return Tools.FetchAsync<{
            templateUniqueIdentifier: string,
            templateName: string, //模版名称
            templateThumbnail: string //缩略图
        }>("Template/SaveTemplate", input, "POST", "multipart/form-data");
    }

    /**
     * 根据模板唯一标识符获取模板数据
     */
    public GetTemplateDataAsync(tempUniqueIdentifier: string) {
        return Tools.FetchAsync<ad_template>("Template/GetTemplateData", {
            tempUniqueIdentifier
        }, "GET");
    }

    /**
     * 设置模板参数
     */
    public SetTemplateParameterAsync(input: InputSetTemplateParameter) {
        return Tools.FetchAsync("Template/SetTemplateParameter", input, "PUT", "multipart/form-data");
    }

    /**
     * 购买模板
     */
    public BuyTemplateAsync(input: InputBuyTemplate) {
        return Tools.FetchAsync("Template/BuyTemplate", input, "POST");
    }
}